import './AdminPage.css'
import { Button } from '@/components/action/Button'
import { BasicPage } from '@/components/layout/BasicPage'
import { useApi } from '@/hooks/useApi'
import { cn } from '@/utilities/misc'
import { routes } from '@/utilities/routes'
import { tenantListSpec, type TenantRow } from 'aevocam-rest-api-spec'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export function AdminPage() {

  const api = useApi({
    requireLogin: true,
    adminOnly: true,
  })

  const [tenants, setTenants] = useState<TenantRow[]>([])

  useEffect(() => {
    api.request(tenantListSpec).then(res => {
      setTenants(res.data?.tenants ?? [])
    })
  }, [])

  return (
    <BasicPage
      title='System administration'
      className='AdminPage'
      toolbarButtons={<>
        <Button
          label='My account'
          icon='chevronLeft'
          href={routes.home()}
        />
        <Button
          label='Articles'
          icon='list'
          href={routes.adminKbArticles()}
        />
        <Button
          label='Users'
          icon='list'
          href={routes.adminUsers()}
        />
        <Button
          label='New tenant'
          icon='plus'
          href={routes.tenantEdit('new')}
        />
        <Button
          label='Icons'
          icon='grid32'
          href={routes.adminIcons()}
        />
      </>}
    >

      <p>Staff administration (admins only)</p>

      <div className='FlexBricks'>

        <div className='Cutout Wrapped'>
          <h2>Tenants</h2>
          <ul className='TenantList'>
            {tenants.map(tenant => tenant.id && (
              <li
                key={tenant.id}
                className={cn(
                  tenant.disabled && 'Disabled',
                )}
              >
                <Link to={routes.home(tenant.id.toString())}>
                  {tenant.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

      </div>

    </BasicPage>
  )
}
